import { login, getWxUserInfo } from '@/api'
import { getStorage, setStorage } from '@/utils/storage'
import { STORAGE_USERINFO } from '@/config/contant'

const types = {
  HAS_TOKEN: 'HAS_TOKEN',
  USER_INFO: 'USER_INFO',
  USER_TOKEN: 'USER_TOKEN',
  WX_SIGN_IN: 'WX_SIGN_IN',
  USER_SIGN_IN: 'USER_SIGN_IN',
}
const Login = {
  state: {
    HAS_TOKEN: 0,
    USER_INFO: null,
    USER_TOKEN: null,
    GET_USER_INFO: null,
    WX_SIGN_IN: false,
    USER_SIGN_IN: false,
  },
  actions: {
    [types.HAS_TOKEN]: async ({ state, commit }) => {
      const userToken = state[types.USER_TOKEN]
      const userInfo = await getStorage(STORAGE_USERINFO)
      if (userToken) {
        return userToken
      }
      if (userInfo) {
        return userInfo.access_token
      }
      return false
    },
    [types.USER_TOKEN]: async ({ state, commit }, token) => {
      const userinfo = state[types.USER_INFO] || (await getWxUserInfo(token))
      return commit(types.USER_TOKEN, userinfo)
    },
    [types.GET_USER_INFO]: async ({ commit }) => {
      const userStore = await getStorage(STORAGE_USERINFO)
      commit(types.GET_USER_INFO, userStore)
      return userStore
    },
    [types.USER_SIGN_IN]: async ({ dispatch, commit }, opts) => {
      const res = await login(opts)
      setStorage(STORAGE_USERINFO, JSON.stringify(res))
      window.$VM.$vgo.tip('登录成功', 'success')
      dispatch('TOGGLE_LOGIN')
      return commit(types.USER_SIGN_IN, res)
    },
    [types.WX_SIGN_IN]: async ({ commit }, obj) => {
      const userinfo = await getWxUserInfo(obj.token)
      setTimeout(() => {
        window.$VM.$router.push(`/?videoid=${obj.videoid}`)
      }, 100)
      return commit(types.WX_SIGN_IN, { token: obj.token, userinfo })
    },
  },
  mutations: {
    [types.GET_USER_INFO]: async (state, data) => {
      state[types.GET_USER_INFO] = data
    },
    [types.WX_SIGN_IN]: async (state, obj) => {
      const userData = obj.userinfo
      userData.access_token = obj.token
      userData.id = obj.user_id
      state[types.HAS_TOKEN] = obj.token
      state[types.USER_INFO] = userData
      state[types.USER_TOKEN] = obj.token
      state[types.USER_SIGN_IN] = true
      setStorage(STORAGE_USERINFO, JSON.stringify(userData))
    },
    [types.USER_SIGN_IN]: async (state, userData) => {
      state[types.USER_INFO] = userData
      state[types.HAS_TOKEN] = userData
      state[types.USER_TOKEN] = userData.access_token
      state[types.USER_SIGN_IN] = true
    },
  },
}

export default Login
